import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./Pagination.css";
export const Pagination = ({ currentPage, totalPages, onPageChange, }) => {
    if (totalPages <= 1)
        return null;
    const getPageNumbers = () => {
        const delta = 2;
        const range = [];
        for (let i = Math.max(1, currentPage - delta); i <= Math.min(totalPages, currentPage + delta); i++) {
            range.push(i);
        }
        return range;
    };
    const pageNumbers = getPageNumbers();
    return (_jsxs("div", { className: "pagination", children: [_jsx("button", { className: "page-btn", disabled: currentPage === 1, onClick: () => onPageChange(1), children: "\u00AB" }), pageNumbers.map((page) => (_jsx("button", { className: `page-btn ${page === currentPage ? "active" : ""}`, onClick: () => onPageChange(page), children: page }, page))), _jsx("button", { className: "page-btn", disabled: currentPage === totalPages, onClick: () => onPageChange(totalPages), children: "\u00BB" })] }));
};
